import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'assesment'
const baseUrl = process.env.REACT_APP_SERVICE_ASSESMENT_URL
const appCode = process.env.REACT_APP_SERVICE_ASSESMENT_APPCODE
const outputType = 'json'

// Penialian Pegawai
export const penilaianList = 'transaction/penilaian360/list/'
export const penilaianDetail = 'transaction/penilaian360/detail/'
export const penilaianComponent = 'transaction/penilaian360/component/'
export const penilaianDraft = 'transaction/penilaian360/submitdraft/'
export const penilaianFinish = 'transaction/penilaian360/submitfinish/'
export const penilaianBegin = 'transaction/penilaian360/begin/'
export const penilaianDashboard = 'transaction/penilaian360/dashboard/'

// Rekap Penilaian
export const recapDataTable = 'transaction/recap360/list/'
export const recapListPeriod = 'transaction/recap360/listperiod/'
export const detailPeriod = 'transaction/recap360/detailperiod/'
export const recapDetailComponent = 'transaction/recap360/component/'
export const recapDownload = 'transaction/recap360/download/'
export const recapOrganization = 'transaction/recap360/organization/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}